/**
 * Server-side tracking via TAGGRS (managed by Factrics).
 * Replaces the direct Google Tag Manager snippet: GTM is loaded through our own subdomain so it isn't blocked by adblockers.
 **/
export const TAGGRS_URL = 'https://numbers.prokino.nl';
export const TAGGRS_CONTAINER_ID = 'dfwufjtduq';

export const taggrsScript = `
  (function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s);
    j.async=true;
    j.src='${ TAGGRS_URL }/'+i+'.js';
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${ TAGGRS_CONTAINER_ID }');
`;

export const taggrsNoscriptUrl = `${ TAGGRS_URL }/${ TAGGRS_CONTAINER_ID }.html`;

/**
 * Only track on the production deployment, so acceptance (preview) and local builds don't send hits to the live container.
 * NEXT_PUBLIC_VERCEL_ENV is a system env var Vercel exposes to the client ('production' | 'preview' | 'development').
 **/
export const isTrackingEnabled = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
